import React, { FC } from 'react';

import { NoDataIndicationError } from 'src/components/no-data-indication-error/NoDataIndicationError';

import './SingleScanTrendsScreen.scss';

export const SingleScanChartsScreen: FC = () => {
	const mainClasses = 'single-scan-trends-screen';

	return (
		<div className={mainClasses}>
			<div className="lower-empty-state">
				<NoDataIndicationError
					title="No trends available"
					renderTextMessage={() => (
						<>
							The property should include at least two scans in order to <br /> review accessibility
							trends over time.
						</>
					)}
				/>
			</div>
		</div>
	);
};
